import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import PostsFeed from "PostsFeed";
import { useCompany, useReceivedPostsByUser } from "queryHooks";

//for use only on company detail page
const EmbeddedPostsFeed = ({
  userId,
  portfolioId,
  companyName,
  companyIds,
  userAdminCompanyIds,
}) => {

  const [postSectionsFilter, setPostSectionsFilter] = useState([]);
  const [limit, setLimit] = useState(2);

  const companyId = companyIds.length ? companyIds[0] : "";

  const {
    data: company = {},
    status: companyStatus,
    error: companyError,
    isFetching,
  } = useCompany({ companyName });

  const {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    data: userReceivedPosts = [],
    status: userReceivedPostsRequestStatus,
  } = useReceivedPostsByUser({
    userId,
    companyIds,
    postSectionsFilter,
    limit,
  });

  return (
    <React.Fragment>
      <PostsFeed
        posts={
          userReceivedPosts && userReceivedPosts.pages
            ? userReceivedPosts.pages.map((post) => post.data).flat()
            : userReceivedPosts
        }
        postsRequestStatus={userReceivedPostsRequestStatus}
        company={company}
        postSectionsFilter={postSectionsFilter}
        setPostSectionsFilter={setPostSectionsFilter}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onCompanyDetailPage={true}
      />
    </React.Fragment>
  );
};

export default EmbeddedPostsFeed;

EmbeddedPostsFeed.propTypes = {
  userId: PropTypes.string,
  companyIds: PropTypes.array,
};
